import React, { useEffect, useRef } from "react";
import "../styles/faq.css"; // reuse your faq styles

const faqs = [
  {
    question: "Is the invoice generator free to use?",
    answer:
      "Yes, we provide a free version for basic use. Premium features such as custom branding and advanced reports are available in paid plans."
  },
  {
    question: "Can I add my logo and company details?",
    answer:
      "Absolutely. You can upload your logo, customize company details, and personalize the look of every invoice."
  },
  {
    question: "Are the invoices professional and legally valid?",
    answer:
      "Yes. All invoices generated follow standard professional formats and are valid for business use."
  },
  {
    question: "Can I track payments through the invoice generator?",
    answer:
      "Yes. Our system allows you to track paid, pending, and overdue invoices, helping you manage cash flow easily."
  },
  {
    question: "Is my data secure?",
    answer:
      "We use encryption and secure servers to ensure your business and client data remains safe and private."
  },
  {
    question: "Can I generate invoices in different currencies?",
    answer:
      "Yes. You can choose from multiple currencies, making it easy to work with clients locally and internationally."
  }
];

const InvoiceFAQs = () => {

       const servicesRef = useRef(null);
          
       useEffect (() => {
        const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");
         const scrollReveal = () => {
            for (let i = 0; i < revealElements.length; i++) {
             const elementIsInScreen =
            revealElements[i].getBoundingClientRect().top < window.innerHeight / 1.15;
          
          if (elementIsInScreen) {
           revealElements[i].classList.add("revealed");
           } else {
              revealElements[i].classList.remove("revealed");
               }
            }
           };
          
           window.addEventListener("scroll", scrollReveal);
              scrollReveal(); // Initial check
          
              return () => {
                window.removeEventListener("scroll", scrollReveal);
              };
            }, []);

  return (
    <section className="faq-section" ref={servicesRef}>
      <h2 className="faq-title" data-reveal>Frequently Asked Questions</h2>
      <div className="faq-grid">
        {faqs.map((item, index) => (
          <div className="faq-item" key={index} data-reveal>
            <h3 className="faq-question">{item.question}</h3>
            <p className="faq-answer">{item.answer}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default InvoiceFAQs;
